export enum CNXFeatureFlags {
    HideAccessControlEmploymentTypeWhenCreatingCandidate = 'HIDE_ACCESS_CONTROL_EMPLOYMENT_TYPE_WHEN_CREATING_CANDIDATE',
    VendorClientCommunicationForApnDirectSubmittals = 'enable-vendor-client-communication-for-apn-direct-submittals',
    VendorClientCommunicationForNonVMSVendorSubmittals = 'enable-communication-for-non-vms-vendor-submittals',
    SetSendToClientEmailBodyAsStatusChangeNoteFromLiveList = 'set-send-to-client-email-body-as-status-change-note-from-live-list'
}
